import { c as _c } from "react/compiler-runtime";
import { HotelReserveBookingCardDetail } from "@website/accommodation-ui/hotel-reserve-booking-card/hotel-reserve-booking-card-detail";
import { HotelReserveBookingCardWrapper } from "@website/accommodation-ui/hotel-reserve-booking-card/hotel-reserve-booking-card-wrapper";
import { HotelReserveBookingCardType } from "@website/accommodation-ui/hotel-reserve-booking-card/hotel-reserve-booking-card.type";
import { useReverseBookingModal } from "@website/accommodation-ui/hotel-reserve-booking-card/use-reverse-booking-modal";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { Modal } from "@website/ui/modal";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { useRouter } from "next/router";
import { FC } from "react";
import SnappPayLogo from "./assets/snapp_pay_logo.png";
export const HotelReserveBookingCard: FC<HotelReserveBookingCardType> = properties => {
  const $ = _c(59);
  const {
    isLoading,
    nightCount,
    minStay,
    passengersCount: t0,
    total_price,
    price,
    basePrice,
    total_price_off,
    submitDisabled,
    submitDisabledMessage,
    showMinStayAlarm,
    snappPayData
  } = properties;
  const passengersCount = t0 === undefined ? 0 : t0;
  const {
    onModalClose,
    isReservePageOpen,
    onModalOpen
  } = useReverseBookingModal();
  const router = useRouter();
  const hasSelectedDateRange = Boolean(router?.query?.date_from && router?.query?.date_to);
  const isMinimumStayViolated = Boolean(hasSelectedDateRange && minStay && Number(nightCount) < Number(minStay));
  let t1;
  if ($[0] !== submitDisabledMessage) {
    t1 = <p className="text-error text-caption">{submitDisabledMessage}</p>;
    $[0] = submitDisabledMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const submitDisabledMessageError = t1;
  const noDatePrice = basePrice;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-caption text-on-surface-medium-emphasis">قیمت از شبی</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== noDatePrice || $[4] !== router.locale) {
    t3 = numberConvert(numberSeparator(noDatePrice), {
      locale: router.locale
    });
    $[3] = noDatePrice;
    $[4] = router.locale;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `${t3} تومان`;
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="flex flex-col items-start gap-1">{t2}<div className="text-body-1">{t4}</div></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const noDateMessage = t5;
  const t6 = `${snappPayData?.isEligible && snappPayData?.showDownPayment ? "" : "border-outline-thin border"} bg-on-color-high-emphasis shadow-6 fixed inset-x-0 bottom-0 z-20 w-full lg:hidden lg:min-h-[97px]`;
  let t7;
  if ($[8] !== snappPayData?.isEligible || $[9] !== snappPayData?.showDownPayment) {
    t7 = snappPayData?.isEligible && snappPayData?.showDownPayment && <><div className="flex flex-row items-center gap-1 px-6 py-4"><LazyImage src={SnappPayLogo?.src} width={16} height={16} /><span className="text-caption text-on-surface-medium-emphasis">امکان پرداخت قسطی با اسنپ‌‌پی</span></div><div className="bg-outline-thin h-px w-full" /></>;
    $[8] = snappPayData?.isEligible;
    $[9] = snappPayData?.showDownPayment;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== minStay || $[12] !== passengersCount || $[13] !== price || $[14] !== router.locale || $[15] !== router.query?.date_from || $[16] !== router.query?.date_to || $[17] !== showMinStayAlarm || $[18] !== total_price || $[19] !== total_price_off) {
    t8 = router?.query?.date_from && router?.query?.date_to && passengersCount > 0 ? <><div>{total_price ? `${numberConvert(numberSeparator(total_price_off && total_price > total_price_off ? total_price_off : total_price), {
          locale: router.locale
        })} تومان` : price ? `${numberConvert(numberSeparator(price), {
          locale: router.locale
        })} تومان` : null}</div>{minStay && showMinStayAlarm ? <div className="text-error text-caption pt-4">{`${numberConvert(minStay, {
          locale: router.locale
        })} شب حداقل مدت اقامت`}</div> : <div />}</> : <></>;
    $[11] = minStay;
    $[12] = passengersCount;
    $[13] = price;
    $[14] = router.locale;
    $[15] = router.query?.date_from;
    $[16] = router.query?.date_to;
    $[17] = showMinStayAlarm;
    $[18] = total_price;
    $[19] = total_price_off;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== isLoading || $[22] !== nightCount || $[23] !== noDateMessage || $[24] !== passengersCount || $[25] !== router.locale || $[26] !== router.query?.date_from || $[27] !== router.query?.date_to || $[28] !== submitDisabledMessage || $[29] !== submitDisabledMessageError) {
    t9 = submitDisabledMessage && !isLoading ? submitDisabledMessageError : !router?.query?.date_from || !router?.query?.date_to || passengersCount === 0 ? noDateMessage : `${numberConvert(nightCount, {
      locale: router.locale
    })} شب برای ${numberConvert(passengersCount, {
      locale: router.locale
    })} نفر`;
    $[21] = isLoading;
    $[22] = nightCount;
    $[23] = noDateMessage;
    $[24] = passengersCount;
    $[25] = router.locale;
    $[26] = router.query?.date_from;
    $[27] = router.query?.date_to;
    $[28] = submitDisabledMessage;
    $[29] = submitDisabledMessageError;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t8 || $[32] !== t9) {
    t10 = <div className="flex flex-col gap-2"><div className="text-body-1 text-on-surface-high-emphasis">{t8}{t9}</div></div>;
    $[31] = t8;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  const t11 = !isLoading && submitDisabled && hasSelectedDateRange || isMinimumStayViolated;
  const t12 = router?.query?.date_from && router?.query?.date_to ? "\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0631\u0632\u0631\u0648" : "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E";
  let t13;
  if ($[34] !== isLoading || $[35] !== onModalOpen || $[36] !== t11 || $[37] !== t12) {
    t13 = <Button className="mt-auto" disabled={t11} fullWidth={true} loading={isLoading} onClick={onModalOpen} size="large">{t12}</Button>;
    $[34] = isLoading;
    $[35] = onModalOpen;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t10 || $[40] !== t13) {
    t14 = <div className="grid grid-cols-2 gap-2 px-6 pb-6 pt-4">{t10}{t13}</div>;
    $[39] = t10;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t14 || $[43] !== t6 || $[44] !== t7) {
    t15 = <div className={t6}>{t7}{t14}</div>;
    $[42] = t14;
    $[43] = t6;
    $[44] = t7;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== properties) {
    t16 = <div className="hidden lg:block"><HotelReserveBookingCardWrapper><HotelReserveBookingCardDetail {...properties} /></HotelReserveBookingCardWrapper></div>;
    $[46] = properties;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  const t17 = !(router?.query?.date_from && router?.query?.date_to);
  let t18;
  if ($[48] !== properties || $[49] !== t17) {
    t18 = <HotelReserveBookingCardWrapper classes="flex flex-col justify-between"><HotelReserveBookingCardDetail {...properties} datePickerIsOpenAtInit={t17} /></HotelReserveBookingCardWrapper>;
    $[48] = properties;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== isReservePageOpen || $[52] !== onModalClose || $[53] !== t18) {
    t19 = <div className="block lg:hidden"><Modal closeIcon="arrow_forward" headerStyle="!ml-auto !mr-0 !w-fit h-[64px]" iconClassName="!text-2xl" onClose={onModalClose} open={isReservePageOpen} showCloseButton={true}>{t18}</Modal></div>;
    $[51] = isReservePageOpen;
    $[52] = onModalClose;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== t15 || $[56] !== t16 || $[57] !== t19) {
    t20 = <>{t15}{t16}{t19}</>;
    $[55] = t15;
    $[56] = t16;
    $[57] = t19;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  return t20;
};